import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var TextEditingTypingSvg = function TextEditingTypingSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22 2.5v1.44h-1.737v16.118H22V21.5h-1.737v.001H18.78v-.001h-1.736v-1.44h1.736V3.94h-1.736V2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.418 4.075h3.568l5.417 15.58-1.404.462-1.69-4.86H5.095l-1.69 4.86L2 19.655zm-1.823 9.74h7.214l-2.886-8.3H8.482z",
    clipRule: "evenodd"
  }));
};
export var TextEditingTyping = function TextEditingTyping(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: TextEditingTypingSvg
  }));
};